import { gql } from '@apollo/client';

export const MARK_NOTIFICATION_READ_MUTATION = gql`
  mutation MarkAsRead($id: Int!) {
    markRead(id: $id) {
      id
    }
  }
`;